module.exports = __webpack_public_path__ + "static/media/icon-certificacao.97227d83.svg";